import React from "react";
import { useTicketBadge } from "./useTicketBadge";

/**
 * Pastille rouge « Tickets (N) » de la barre latérale. N = tickets porteurs de notifications NON
 * LUES pour l'utilisateur courant (via {@link useTicketBadge}) : elle s'éteint dès qu'il ouvre les
 * tickets concernés, l'état ouvert/fermé n'allume plus rien. Rien ne s'affiche à zéro. En barre
 * repliée, elle se réduit à un point rouge sur l'icône.
 */
export const TicketNavBadge: React.FC<{ collapsed?: boolean }> = ({ collapsed }) => {
	const count = useTicketBadge();
	if (count <= 0) return null;
	if (collapsed) {
		return <span className="absolute right-1.5 top-1.5 h-2 w-2 rounded-full bg-rose-500 ring-2 ring-white" aria-label={`${count} tickets`} />;
	}
	return (
		<span className="ml-auto inline-flex min-w-[1.25rem] items-center justify-center rounded-full bg-rose-500 px-1.5 py-0.5 text-xs font-bold text-white">
			{count}
		</span>
	);
};

export default TicketNavBadge;
